export default __webpack_public_path__ + "static/media/icon_activity.f712875c.svg";